// Validation déclarative des items de la roadmap.
// `answers` est la structure globale : answers[itemId][fieldKey] = valeur.

const countLines = (str) =>
  String(str || '')
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean).length;

export function isFieldValid(field, value, answers) {
  const v = field.validation || {};
  const str = value == null ? '' : value;

  if (v.mustBeTrue) return value === true;
  if (v.equals != null) return str === v.equals;

  if (field.kind === 'number' || v.min != null || v.gt) {
    const num = parseFloat(str);
    if (Number.isNaN(num)) return false;
    if (v.min != null && num < v.min) return false;
    if (v.gt) {
      const ref = answers?.[v.gt.itemId]?.[v.gt.fieldKey];
      const refNum = parseFloat(ref);
      if (Number.isNaN(refNum) || num <= refNum) return false;
    }
    return true;
  }

  if (v.minLines != null) return countLines(str) >= v.minLines;
  if (v.minChars != null) return String(str).trim().length >= v.minChars;
  if (v.required) return String(str).trim().length > 0;

  return String(str).trim().length > 0;
}

export function isItemComplete(item, answers) {
  const itemAnswers = answers?.[item.id] || {};
  return item.fields.every((f) =>
    isFieldValid(f, itemAnswers[f.key], answers)
  );
}

// Message d'aide quand un champ n'est pas encore valide.
export function fieldHint(field, value, answers) {
  const v = field.validation || {};
  const str = value == null ? '' : String(value);
  if (v.mustBeTrue && value !== true) return 'À cocher pour valider.';
  if (v.equals != null && str !== v.equals)
    return `Sélectionne « ${v.equals} » pour valider.`;
  if (v.minLines != null) {
    const n = String(str)
      .split('\n')
      .map((l) => l.trim())
      .filter(Boolean).length;
    return `${n}/${v.minLines} lignes minimum.`;
  }
  if (v.minChars != null) {
    const n = str.trim().length;
    if (n < v.minChars) return `${n}/${v.minChars} caractères minimum.`;
  }
  if (v.min != null) {
    const num = parseFloat(str);
    if (Number.isNaN(num)) return 'Indique un nombre.';
    if (num < v.min) return `Minimum ${v.min}.`;
  }
  if (v.gt) {
    const ref = answers?.[v.gt.itemId]?.[v.gt.fieldKey];
    return `Doit être supérieur à la Formule 1 (${ref || '—'} €).`;
  }
  return '';
}
